import React, { MouseEventHandler, useEffect, useState } from 'react';
import { SVGIcon } from '../../../components/atoms/SVG';
import { ButtonMinorAction } from '../../../components/molecules/Btn/ButtonWrapper';
import { ButtonRefType } from '../../../components/molecules/Btn/Btn';

type BlockBarAnchorProps = {
  onClick: MouseEventHandler<HTMLAnchorElement>;
  text: string;
  svgSpriteId: SVGIcon;
  href?: string;
  routing?: boolean;
  ref?: ButtonRefType;
  'aria-controls'?: string;
  'aria-expanded'?: boolean;
};

export function BlockBarAnchor({
  onClick,
  text,
  svgSpriteId,
  href,
  routing,
  ref,
  'aria-controls': ariaControls,
  'aria-expanded': ariaExpanded,
}: BlockBarAnchorProps) {
  return (
    <div className="block-bar__button">
      <ButtonMinorAction
        text={text}
        icon={svgSpriteId}
        onClick={onClick}
        href={href}
        routing={routing}
        reference={ref}
        ariaControls={ariaControls}
        ariaExpanded={ariaExpanded}
      />
    </div>
  );
}

export const useBlockBarCreateHref = (
  currentActiveView: string | undefined,
  viewHrefMap: Record<string, string | undefined | null>,
  id: string
) => {
  const [currentActiveViewHref, setCurrentActiveViewHref] = useState(
    `${currentActiveView ? viewHrefMap[currentActiveView] : null}#${id}`
  );

  useEffect(() => {
    setCurrentActiveViewHref(`${currentActiveView ? viewHrefMap[currentActiveView] : null}#${id}`);
  }, [currentActiveView, id, viewHrefMap]);

  return currentActiveViewHref;
};
